(function () {
  'use strict';

  var INIT_FLAG = 'aeyaLoyaltyBannerInited';

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';

    var announce = document.querySelector('.aeya-announcement');
    var announceSection = (announce && announce.closest('.shopify-section')) || announce;

    function applyHeight() {
      var a = announceSection ? Math.round(announceSection.getBoundingClientRect().height) : 0;
      root.style.setProperty('--aeya-loyalty-banner-h', 'calc(100dvh - ' + a + 'px)');
    }

    applyHeight();
    requestAnimationFrame(applyHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyHeight);

    if ('ResizeObserver' in window && announceSection) {
      new ResizeObserver(applyHeight).observe(announceSection);
    }

    var rafPending = false;
    function onResize() {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { applyHeight(); rafPending = false; });
    }
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('orientationchange', onResize);
  }

  function initAll() {
    document.querySelectorAll('[data-aeya-loyalty-banner]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-aeya-loyalty-banner]');
    if (root) init(root);
  });
})();
